import React from "react";
import { useTranslation } from "react-i18next";

import { legendStyle, LegendGradientItemStyle } from "./style";
import { snowLegendColors } from "../util/colors";

//TODO: check if this can be replaced with the array
export const snow5CMLegendLegendPerLevel = (t, level) => {
  return [
    `${t("levels.noData")} : (ps(%) < 0)`,
    `${t("levels.low")} : (0 ≤ ps(%) < 30)`,
    `${t("levels.moderate")} : (30 ≤ ps(%) < 60)`,
    `${t("levels.significant")} : (60 ≤ ps(%) < 80)`,
    `${t("levels.high")} : (80 ≤ ps(%) < 100)`,
  ][level];
};

export const snow5CMLegendLegendLevels = () => {
  return [0, 30, 60, 80, 101];
  // 4 numerical intervals for normal legend (1,2,3,4)
  // Other values are considered as "no data"
};

export const Snow5CMLegend = () => {
  const { t } = useTranslation();

  const snow5CMLegendLegendLevelsStr = [
    `${t("levels.low")} : (0 ≤ ps(%) < 30)`,
    `${t("levels.moderate")} : (30 ≤ ps(%) < 60)`,
    `${t("levels.significant")} : (60 ≤ ps(%) < 80)`,
    `${t("levels.high")} : (80 ≤ ps(%) < 100)`,
  ];

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("riskAssessment.snow")} (ITA) - 5cm</b>
      </div>

      <LegendGradientItemStyle
        colors={snowLegendColors}
        labels={snow5CMLegendLegendLevelsStr}
      ></LegendGradientItemStyle>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          ps (%) = {t("legend.snowAnnualProbability")} &lt; 5cm/{t("day")}
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, {t("legend.dataFromRAIN")}
        </span>
      </div>
    </div>
  );
};
